import * as yup from 'yup';

export const addSignalTypesValidation = yup.object().shape({
    name: yup.string().required(),
    tax: yup.bool().required(),
});
